import type { Entity } from '@thinkalpha/ui-types/types/admin/index';
import { createLegacyInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const axios = createLegacyInstance({ baseURL: appConfig.accessApi });

export const getSubjectsByIds = async (ids: string[]) => {
    const { data } = await axios.get<Entity[]>(`/entities`, { params: { ids } });
    return data;
};
